export default "__VITE_ASSET__Bv81Snbg__"